import type { GeneratedStory } from "@/lib/mock-story";

export interface StoryState {
  step: number;
  goal: string;
  name: string;
  gender: "he" | "she" | "";
  age: number;
  temperament: string;
  themes: string;
  situation: string;
  heroFormat: "child" | "companion";
  length: "short" | "medium" | "long";
  tone: "calm" | "adventure" | "humor";
  paid: boolean;
  storyData: GeneratedStory | null;
}

const STORAGE_KEY = "tihaya-skazka-state";

export const defaultState: StoryState = {
  step: 0,
  goal: "",
  name: "",
  gender: "",
  age: 5,
  temperament: "",
  themes: "",
  situation: "",
  heroFormat: "child",
  length: "medium",
  tone: "calm",
  paid: false,
  storyData: null,
};

export function loadState(): StoryState {
  if (typeof window === "undefined") return { ...defaultState };
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved) return { ...defaultState, ...JSON.parse(saved) };
  } catch { /* ignore */ }
  return { ...defaultState };
}

export function saveState(state: StoryState) {
  if (typeof window === "undefined") return;
  localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
}
